
import {Injectable} from '@angular/core';
import {Page} from '../model/page';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {ICompanyMapping} from '../views/teamwork-reports/company-mapping/interfaces/ICompanyMapping';
import {ICustomer} from '../views/customers/customer';

@Injectable()
export class CompanyMappingService extends GeneralService {

constructor(
    protected http: HttpClient
    ) {
        super ( http );
    }

    public getDataList ( page: Page ): Observable<any> {
        const url = '/company-mapping/index';
        return this.getRestList ( page, url );
    }

    public update(companyMapping: ICompanyMapping): Observable<any> {
        return this.http.put(this.apiUrl + '/company-mapping/edit', companyMapping)
            .catch(this.handleError);
    }

    public initialize () {
        return {
            CT1_ID : null,
            CT1_NEW : null,
            CT1_TAG_ID : null,
            CT1_TAG_NAME: null,
            CT1_CO1_ID : null,
            CT1_CO1_NAME : null,
            CT1_MODIFIED_BY : null,
            CT1_MODIFIED_ON : null,
            CT1_CREATED_ON : null,
            ACTIONS : null
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/company-mapping.service.ts